import { render, staticRenderFns } from "./addStaff.vue?vue&type=template&id=32ff7900&scoped=true&"
import script from "./addStaff.vue?vue&type=script&lang=js&"
export * from "./addStaff.vue?vue&type=script&lang=js&"
import style0 from "./addStaff.vue?vue&type=style&index=0&id=32ff7900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff7900",
  null
  
)

export default component.exports